package io.janni.wedding.di

import io.janni.wedding.viewmodels.SlideshowViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

val appModule = module {
    viewModel { SlideshowViewModel() }
}
